/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import LocalizationComponent from '../../../Localization/LocalizationComponent';
import ComponentBase from '../../ComponentBase';
import UpdateableComponentBase from './UpdateableComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

export enum TextTransformOption
{
    None,
    Uppercase,
    Lowercase
}
// tslint:disable-next-line:typedef
const ccTextTransformationOptions = cc.Enum(TextTransformOption);

/**
 * Implementation of [[UpdateableComponentBase]] for updating [[cc.Label]]s or
 * [[cc.RichText]] when culture changes.
 */
@cc._decorator.ccclass
export default class UpdateableResourceComponent extends UpdateableComponentBase<cc.Label | cc.RichText, any>
{
    @property({ displayName: 'Local Key', visible: true, override: true })
    protected _observableInstanceID: string = 'group/property';
    public get LocalKey(): string { return this._observableInstanceID; }
    public set LocalKey(value: string) { this._observableInstanceID = value; }

    @property({ type: ccTextTransformationOptions })
    protected textTransformOption: TextTransformOption = TextTransformOption.None;
    public set TextTransformOption(value: TextTransformOption) { this.textTransformOption = value; }

    protected component: cc.Label | cc.RichText = null;
    protected bindLocalization: boolean = false;

    /** @hidden */
    private _translatedValue: string = '';

    /** @hidden */
    protected setContexts(): void
    {
        this.localRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.component = ComponentBase.GetFirstComponent<cc.Label>(this.node, cc.Label, cc.RichText);
    }

    protected findObservable(): void
    {
        this.Observable = this.localRef.Value;
    }

    protected valueChangedHandler = (): void =>
    {
        if (!this.localRef.Value) { return; }
        let translation: string = this.localRef.Value.GetStringResource(this._observableInstanceID);

        if (translation)
        {
            switch (this.textTransformOption)
            {
                case TextTransformOption.Uppercase:
                    translation = translation.toUpperCase();
                    break;
                case TextTransformOption.Lowercase:
                    translation = translation.toLocaleLowerCase();
                    break;
                case TextTransformOption.None:
                default:
                    break;
            }
            this._translatedValue = translation;
            this.updateUI();
        }
    }

    protected updateUI = (event?: cc.Event.EventCustom) =>
    {
        if (!this._translatedValue
            || this.component.string === this._translatedValue) { return; }

        this.component.string = this._translatedValue;
    }
}
